/**
 * Formatters for the Interview Links views, in ONE place.
 *
 * Slot times are pinned to Europe/Berlin: a recruiter reading "Thu 27 Aug,
 * 09:00" means the interviewer's working morning, and rendering it in the
 * viewer's own timezone would shift it. Shared because the link form's hint,
 * the at-risk banner and the invite dialog all render the same slot data —
 * three private copies drifted the moment one of them added the year.
 */
export const TZ = 'Europe/Berlin';

export const dayFmt = new Intl.DateTimeFormat('en-GB', {
  timeZone: TZ,
  weekday: 'short',
  day: 'numeric',
  month: 'short',
});

export const timeFmt = new Intl.DateTimeFormat('en-GB', {
  timeZone: TZ,
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});
